// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  box-sizing: border-box;
  font: 18px open_sans, Helvetica, Arial, sans-serif;
  font-weight: 400;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  padding: 0;
  background: #f1f1f1;
  color: #333;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

article,
/*aside,*/
/*details,*/
/*figcaption,*/
/*figure,*/
footer,
header,
main,
/*menu,*/
/*nav,*/
section,
form,
div {
  /* display: flex; */
  /* flex-direction: column; */
  flex: 0 1 auto; /* ie10 bug */
  width: auto;
}

/* setting div to be display flex was not a good decision (was inspired by react
native). The .noColumn hack was a quick fix to deal with this in dependencies
that requires divs to be a certain way. */
.noColumn .variable-row {
  flex-direction: row;
}

.noColumn div {
  display: block;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
button {
  margin: 0;
  font-weight: 300;
}

h1 {
  font-size: 30px;
  line-height: 30px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #3f4044;
}

h2 {font-size: 24px; line-height: 30px; color: #3c3c3c;}
p {font-size: 18px; line-height: 28px;}
a {text-decoration: none;}

textarea,
input,
button {
  border: 0;
  outline: 0;
  border-radius: 0;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
  font: 20px open_sans, Helvetica, Arial, sans-serif;
  font-weight: 300;
}

textarea,
input {
  border: 0;
  background: #f3f3f3;
  font-size: 20px;
  color: #888;
}

label {font-size: 12px; line-height: 12px;}

input {
  padding: 5px 25px;
}

textarea {
  font-family: Helvetica, Arial, sans-serif;
  padding: 20px 25px;
}

button {
  font-size: 14px;
  background-color: #ff3154;
  color: #fff;
}

button::-moz-focus-inner {
  border: 0;
}

pre {
  box-sizing: border-box;
  font: 18px open_sans, Helvetica, Arial, sans-serif;
  font-weight: 400;
}

[data-reach-menu] {
  font-family: sans-serif;
  display: block;
  position: absolute;
}

.selectButton[aria-expanded="true"] {
  background: rgba(248, 248, 248, 1);
}
`, "",{"version":3,"sources":["webpack://./src/css/g_default.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kDAAkD;EAClD,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;EAC9B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;EAaE,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc,EAAE,aAAa;EAC7B,WAAW;AACb;;AAEA;;yCAEyC;AACzC;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;;EAQE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,IAAI,eAAe,EAAE,iBAAiB,EAAE,cAAc,CAAC;AACvD,GAAG,eAAe,EAAE,iBAAiB,CAAC;AACtC,GAAG,qBAAqB,CAAC;;AAEzB;;;EAGE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,wCAAwC;EACxC,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA,OAAO,eAAe,EAAE,iBAAiB,CAAC;;AAE1C;EACE,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["html {\n  box-sizing: border-box;\n  font: 18px open_sans, Helvetica, Arial, sans-serif;\n  font-weight: 400;\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  background: #f1f1f1;\n  color: #333;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: inherit;\n}\n\narticle,\n/*aside,*/\n/*details,*/\n/*figcaption,*/\n/*figure,*/\nfooter,\nheader,\nmain,\n/*menu,*/\n/*nav,*/\nsection,\nform,\ndiv {\n  /* display: flex; */\n  /* flex-direction: column; */\n  flex: 0 1 auto; /* ie10 bug */\n  width: auto;\n}\n\n/* setting div to be display flex was not a good decision (was inspired by react\nnative). The .noColumn hack was a quick fix to deal with this in dependencies\nthat requires divs to be a certain way. */\n.noColumn .variable-row {\n  flex-direction: row;\n}\n\n.noColumn div {\n  display: block;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nbutton {\n  margin: 0;\n  font-weight: 300;\n}\n\nh1 {\n  font-size: 30px;\n  line-height: 30px;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: #3f4044;\n}\n\nh2 {font-size: 24px; line-height: 30px; color: #3c3c3c;}\np {font-size: 18px; line-height: 28px;}\na {text-decoration: none;}\n\ntextarea,\ninput,\nbutton {\n  border: 0;\n  outline: 0;\n  border-radius: 0;\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);\n  font: 20px open_sans, Helvetica, Arial, sans-serif;\n  font-weight: 300;\n}\n\ntextarea,\ninput {\n  border: 0;\n  background: #f3f3f3;\n  font-size: 20px;\n  color: #888;\n}\n\nlabel {font-size: 12px; line-height: 12px;}\n\ninput {\n  padding: 5px 25px;\n}\n\ntextarea {\n  font-family: Helvetica, Arial, sans-serif;\n  padding: 20px 25px;\n}\n\nbutton {\n  font-size: 14px;\n  background-color: #ff3154;\n  color: #fff;\n}\n\nbutton::-moz-focus-inner {\n  border: 0;\n}\n\npre {\n  box-sizing: border-box;\n  font: 18px open_sans, Helvetica, Arial, sans-serif;\n  font-weight: 400;\n}\n\n[data-reach-menu] {\n  font-family: sans-serif;\n  display: block;\n  position: absolute;\n}\n\n.selectButton[aria-expanded=\"true\"] {\n  background: rgba(248, 248, 248, 1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
